import { OperatoriesView, useToast } from '@elva/ui';
import { useLocationStore, useWorkspaceLabel } from '@elva/platform';
import { useMemo } from 'react';
import { ElvaSectionState } from '@/components/ElvaSectionState';
import { adaptPracticeOperatories, practiceOperatoryToApi } from '../adapters/settingsAdapters';
import { useOperatories, useUpdateOperatory } from '../hooks/useOperatories';

/** Practice management › Operatories (spec 15 §6). The list stays a list, on the operatories API. */
export function SettingsOperatoriesPage() {
  const workspaceLabel = useWorkspaceLabel();
  const locationId = useLocationStore((s) => s.selectedCoreLocationId);
  const { data, isLoading, isError } = useOperatories(true);
  const updateOperatory = useUpdateOperatory();
  const { toast } = useToast();

  const operatories = useMemo(
    () => adaptPracticeOperatories(data?.operatories ?? []),
    [data?.operatories],
  );

  return (
    <ElvaSectionState isLoading={isLoading || !data} isError={isError}>
      {data ? (
        <OperatoriesView
          key={locationId ?? 'none'}
          operatories={operatories}
          location={workspaceLabel}
          lastSync="—"
          onChange={async (next) => {
            const original = data.operatories.find((o) => o.id === next.id);
            if (!original) return;
            try {
              await updateOperatory.mutateAsync({ id: next.id, data: practiceOperatoryToApi(next, original) });
            } catch {
              toast({ title: `Could not save ${next.name}`, variant: 'error' });
            }
          }}
        />
      ) : null}
    </ElvaSectionState>
  );
}
